export default class TicketTransformer {
  constructor(data) {
    this.data = data;
  }

  transform() {
    const items = this.data;

    // find only Leg items where Leg Booking has the 'print_ticket' toggle selected in CMS
    const legs = items.filter((item) => item._modelApiKey === 'leg_booking' && item.printTicket === true);
    const tickets = legs.map((leg) => leg.tickets);
    const ticketUrls = tickets.flat().map((ticket) => ticket.url);
    return {
      ticketUrls
    };
  }
}
